import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import styles from "./styles/TabContent.module.css";
import clsx from "clsx";
import { Container } from "react-bootstrap";

const TabContent = forwardRef((props, ref) => {
  const {
    data, // data = [{id, title, content}]
    className,
    navClassName,
    isAlignCenter,
    topContent,
    defaultTabIndex,
  } = props;

  let tabActive = defaultTabIndex === -1 ? 0 : defaultTabIndex;

  return (
    <div className={className}>
      <nav className={clsx("shadow-sm", navClassName)}>
        <Container>
          {topContent}
          <div
            className={clsx(
              "nav tab_crse",
              isAlignCenter && "justify-content-center"
            )}
            ref={ref}
          >
            {data.map((tab, index) => {
              return (
                <a
                  key={tab.id}
                  className={clsx(
                    "nav-item nav-link",
                    styles.tabLink,
                    tabActive === index && "active"
                  )}
                  data-toggle="tab"
                  href={`#${tab.id}`}
                >
                  {tab.title}
                </a>
              );
            })}
          </div>
        </Container>
      </nav>
      <Container className="tab-content" id="myTabContent">
        {data.map((tab, index) => {
          return (
            <div
              key={tab.id}
              id={tab.id}
              className={clsx(
                "tab-pane fade show",
                tabActive === index && "active"
              )}
            >
              {tab.content}
            </div>
          );
        })}
      </Container>
    </div>
  );
});

/* required: display name */
TabContent.displayName = "TabContent";

/* required: props types */
TabContent.propTypes = {
  data: PropTypes.array,
  isAlignCenter: PropTypes.any,
  className: PropTypes.any,
  navClassName: PropTypes.any,
  topContent: PropTypes.element,
  defaultTabIndex: PropTypes.number,
};

/* required: default props */
TabContent.defaultProps = {
  data: [],
  isAlignCenter: true,
  defaultTabIndex: -1,
};

export { TabContent };
